import { c as _c } from "react/compiler-runtime";
import React from "react";
import elements from "./TeasersItem.module.scss";
import type { SanityImageObject } from "@sanity/image-url";
import { ResponsiveImage } from "../../../shared/responsiveimage";
import { LinkType, Links } from "../Links/Links";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
import { PortableText } from "next-sanity";
import { customComponentRenderers } from "../Paragraph/Citation";
export interface TeasersItemProps {
  id: string;
  title: string;
  // Paragraph has been converted to portable text, but there might be legacy data that still uses string
  paragraph: string | Array<any>;
  links?: (LinkType | NavLink)[];
  image: SanityImageObject;
  inverted?: boolean;
}
export const TeasersItem: React.FC<TeasersItemProps> = t0 => {
  const $ = _c(23);
  const {
    title,
    paragraph,
    links,
    image,
    inverted
  } = t0;
  let classNames;
  if ($[0] !== inverted) {
    classNames = [elements.teaser];
    if (inverted) {
      classNames.push(elements.inverted);
    }
    $[0] = inverted;
    $[1] = classNames;
  } else {
    classNames = $[1];
  }
  const paragraphIsPortableText = Array.isArray(paragraph);
  const t1 = classNames.join(" ");
  let t2;
  if ($[2] !== image) {
    t2 = <div className={elements.teaserimage}><ResponsiveImage image={image} layout="cover" sizes="(min-width: 1521px) 700px, (min-width: 1181px) 550px, 90vw" /></div>;
    $[2] = image;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== title) {
    t3 = <h3>{title}</h3>;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== paragraph || $[7] !== paragraphIsPortableText) {
    t4 = paragraphIsPortableText ? <div className={elements.teaserparagraph}><PortableText value={paragraph} components={customComponentRenderers} /></div> : <div className={elements.teaserparagraph}>{paragraph}</div>;
    $[6] = paragraph;
    $[7] = paragraphIsPortableText;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== links) {
    t6 = links && <Links links={links} buttons={true} />;
    $[12] = links;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <div className={elements.teaserlinks}>{t6}</div>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t7) {
    t8 = <div className={elements.teasertext}>{t5}{t7}</div>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t8) {
    t9 = <div className={t1}>{t2}{t8}</div>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};